import { render, staticRenderFns } from "./ProductPromotion.vue?vue&type=template&id=01cefe30&scoped=true&"
import script from "./ProductPromotion.vue?vue&type=script&lang=js&"
export * from "./ProductPromotion.vue?vue&type=script&lang=js&"
import style0 from "./ProductPromotion.vue?vue&type=style&index=0&id=01cefe30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cefe30",
  null
  
)

export default component.exports